import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "primereact/editor";

import DashboardLayout from "./components/Layout";
import { createTicketType, getTicketTypeById, updateTicketType } from "../../api/ticket-types";

const TicketTypeFormPage = () => {
  const { eventId, id } = useParams();
  const isEdit = !!id;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
    formState: { isSubmitting },
  } = useForm();

  useEffect(() => {
    if (isEdit) {
      getTicketTypeById(eventId, id).then((res) => {
        const data = res?.data?.data;
        if (data) {
          setValue("name", data.name.az);
          setValue("price", data.price);
          setValue("salePrice", data.salePrice);
          setValue("description", data.description.az);
          setValue("count", data.count);
          setValue("isActive", data.isActive);
        }
      });
    }
  }, [isEdit, setValue, eventId, id]);

  const onSubmit = async (formData) => {
    const payload = {
      name: { az: formData.name },
      price: Number(formData.price),
      salePrice: formData.salePrice ? Number(formData.salePrice) : undefined,
      description: { az: formData.description },
      count: formData.count ? Number(formData.count) : undefined,
      isActive: formData.isActive,
    };

    if (isEdit) {
        await updateTicketType(eventId, id, payload);
    } else {
        await createTicketType(eventId, payload);
    }

    navigate(`/dashboard/${eventId}/ticket-types`);
  };

  return (
    <DashboardLayout id={eventId}>
      <div className="max-w-2xl mx-auto mt-10 bg-white p-8 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-6">
          {isEdit ? "🎟️ Bilet Növünü Düzəlt" : "➕ Yeni Bilet Növü Əlavə Et"}
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Adı (AZ)</label>
            <input
              {...register("name", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Cari Qiymət (₼)</label>
            <input
              type="number"
              step="0.01"
              {...register("price", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Əvvəlki qiymət (₼)</label>
            <input
              type="number"
              step="0.01"
              {...register("salePrice")}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Açıqlama</label>

            <Controller
              name="description"
              control={control}
              defaultValue=""
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <Editor
                  value={field.value}
                  onTextChange={(e) => field.onChange(e.htmlValue)}
                  style={{ height: '320px' }} 
                />
                )}
              />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Limit (istəyə bağlı)</label>
            <input
              type="number"
              {...register("count")}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register("isActive")}
              className="mr-2"
            />
            <label className="text-sm text-gray-700">Aktivdir</label>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            {isEdit ? "Yadda saxla" : "Əlavə et"}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default TicketTypeFormPage;
